<template>
	<div class="checkout-address-selector mb-10">
		<div class="ux-radio-list is-horz mb-6">
			<ux-radio v-if="userAddressList.length > 0" label="Existing address" data="existingAddr" :value="shipAddrType" @input="setNewAddress(false); setPickUpInStore(false);" />
			<ux-radio label="New address" data="addNew" :value="shipAddrType" @input="setNewAddress(true); setPickUpInStore(false);" />
			<ux-radio label="Pick Up In Store" data="pickUpInStore" :value="shipAddrType" @input="setNewAddress(true); setPickUpInStore(true);" />
		</div>

		<template v-if="pickUpInStore">
			<div>
				<p class="mb-2"><strong>Maple Ridge / Head Office</strong></p>
				<p class="mt-2">Will notify when order is ready for pickup.</p>
			</div>
		</template>

		<template v-else-if="addNew">
			<address-form :address.sync="newAddress" :addressType="addressType" />
		</template>

		<template v-else>
			<div class="row">
				<div v-for="addr in userAddressList" :key="addr.id" class="col-md-6">
					<address-option :address="addr" :selected="selected" @update:selected="changeAddress($event)" />
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

import AddressForm from 'frontend/addresses/comp/AddressForm.vue';
import { defaultAddr } from 'frontend/addresses/info';

import AddressOption from './AddressOption.vue';

export default {
	components: { AddressForm, AddressOption },


	props: {
		addressType: {
			type: String,
			required: true,
			validator: val => ['shipping', 'billing'].includes(val),
		}
	},

	data()
	{
		return {
			addNew: false,
			selected: '',
			pickUpInStore: false,
			//newAddress: { ...defaultAddr },
		}
	},

	computed: {
		...mapGetters('addresses', ['userAddressList']),
		...mapState({
			addresses: state => state.addresses.addresses,
			order: state => state.checkout.order,
		}),

		selectedAddress()
		{
			return this.addresses[this.selected];
		},

		newAddress: {
			get()
			{
				return this.order[`${this.addressType}Address`];
			},

			set(addr)
			{
				if (this.addNew)
				{
					var field = `${this.addressType}Address`;
					this.updateOrder({ [field]: { ...addr, is_new: true } });
				}
			}
		},

		shipAddrType() {
			if (this.pickUpInStore)
				return 'pickUpInStore';
			else if (!this.addNew)
				return 'existingAddr';
			else
				return 'addNew';
		},
	},

	methods: {
		...mapMutations('checkout', ['updateOrder']),

		// get primary address 
		getPrimaryAddress()
		{
			var field = `is_primary_${this.addressType}`;
			var primary = this.userAddressList.find(a => a[field]);

			return primary || this.userAddressList[0];
		},

		// change between existing user addresses
		changeAddress(id)
		{
			var field = `${this.addressType}Address`;
			var addr = this.addresses[id];

			// if address is valid then load it into the order state
			if (addr)
			{
				this.selected = id;
				this.updateOrder({ [field]: { ...addr } });
			}
		},

		// select the primary shipping/billing address
		selectPrimaryAddress()
		{
			var primary = this.getPrimaryAddress();
			var field = `${this.addressType}Address`;
			
			// if found then change address
			if (primary)
			{
				this.changeAddress(primary.id);
			}
			// otherwise clear selection
			else
			{
				this.updateOrder({ [field]: {} });
				this.selected = '';
			}
		},

		setPickUpInStore(flag) {
			this.pickUpInStore = flag;
			if (flag) {
				this.newAddress = { ...defaultAddr, id: 0 };
			}
			this.updateOrder({ pickUpInStore: flag });
		},

		// toggle between adding a new address or selecting an existing one
		setNewAddress(flag)
		{
			this.addNew = flag;

			// if entering a new address then load a blank address into order state
			if (flag)
				this.newAddress = { ...defaultAddr, id: 0 };
			// otherwise select the primary shipping/billing address
			else if (this.userAddressList.length > 0)
				this.selectPrimaryAddress();
		}
	},

	mounted()
	{
		if (this.userAddressList.length > 0)
			this.selectPrimaryAddress();
		else
			this.setNewAddress(true);
	}
}
</script>